import * as React from 'react';
import { IconButton } from "@mui/material";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';



export class DeleteButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: props.data,
            callback: props.callback
        }

        console.log('DeleteButton', this.state);
        this._handleClick = this._handleClick.bind(this);
    }

    _handleClick = () => {
        var x = Object.assign({}, this.state.customer);
        console.log('Manage button initiated',x);
        this.state.callback(this.state.data);
    }

    render() {
        return (
            <IconButton name="delete" className="iconDelete"  disabled={this.props?.disabled || false}  aria-label="Delete" onClick={this._handleClick}>
                <DeleteForeverIcon className="iconWidget"/>
            </IconButton>            
        )
    }
}
